import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Container from '@components/ui/Container/Container'
import { findRichTextLink } from '@lib/findRichTextLink'

import Media from '@components/ui/Media/Media'
import { FC } from 'react'
import { MediaPicker } from 'types/mediaPicker'
import { UmbracoLink } from 'types/umbracoLink'
import { ModuleProps } from '..'
import styles from './ImageWithContent.module.scss'

export type ImageWithContentProps = {
  richText?: string
  mediaPicker?: MediaPicker
  link?: UmbracoLink
  reversed?: boolean
  textColor?: string
  backgroundColor?: string
  backgroundColorPicker?: string
} & ModuleProps

const ImageWithContent: FC<ImageWithContentProps> = ({
  richText,
  mediaPicker,
  reversed,
  textColor,
  backgroundColor,
  backgroundColorPicker,
  link,
  lcp,
}) => {
  return (
    <Container
      backgroundColor={backgroundColorPicker ?? backgroundColor}
      color={textColor}
    >
      <div className={`${styles.container} ${reversed && styles.reversed}`}>
        <div className={styles.innerContainer}>
          <Link
            link={findRichTextLink(richText)}
            className={styles.contentContainer}
          >
            <Media
              mediaWithCrops={mediaPicker}
              mediaClassName={styles.media}
              className={styles.mediaContainer}
              priority={lcp}
              sizes="(min-width: 1520px) 740px,(min-width: 767px) 50vw, 100vw"
            />
          </Link>

          <div className={styles.contentContainer}>
            <div className={styles.innerTextContent}>
              <TrustedHtml className={styles.richText} html={richText} />
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default ImageWithContent
